import React, { useEffect } from 'react';
import type { ICellRendererParams } from 'ag-grid-community';
import type { ReviewCellRendererProps } from '../helpers';
import { cn } from '@/lib/utils';

export const ErrorCellRenderer = ({
  data,
  errors,
  node,
  editingSeriesId,
  setEditingSeriesId,
}: ICellRendererParams & ReviewCellRendererProps) => {
  const currentRowErrors = errors.filter((error) => error.seriesId === data.seriesId);
  const isError = currentRowErrors.some((e) => !e.isValid);

  useEffect(() => {
    if (node.expanded && editingSeriesId !== data.seriesId) {
      node.setExpanded(false);
    }
  }, [data.seriesId, editingSeriesId, node]);

  const handleClick = () => {
    if (node.expanded) {
      setEditingSeriesId('');
    } else {
      setEditingSeriesId(data.seriesId);
    }
    node.setExpanded(!node.expanded);
  };

  const getErrorText = (): string => {
    if (currentRowErrors.length === 0) {
      return '';
    }
    return isError ? 'Errors' : 'No errors';
  };

  if (currentRowErrors?.length > 0) {
    return (
      <button
        type="button"
        className={cn([
          'h-full w-[85px] py-[8px] text-center ',
          'border-l border-solid border-l-venn-grey-30 border-y-0 border-r-0',
          node.expanded
            ? isError
              ? 'bg-venn-error'
              : 'bg-venn-dark-blue'
            : isError
              ? 'bg-venn-lighter-error'
              : 'bg-venn-white hover:bg-venn-dark-blue/5',
        ])}
        onClick={handleClick}
      >
        <div
          className={cn([
            'text-[11px] uppercase font-bold tracking-[1px] leading-[16px] h-full',
            node.expanded
              ? isError
                ? 'text-venn-white'
                : 'text-venn-white'
              : isError
                ? 'text-venn-error'
                : 'text-venn-deep-dark-blue',
          ])}
        >
          {node.expanded ? 'Close' : getErrorText()}
        </div>
      </button>
    );
  }

  return null;
};
